<template>
  <div class="crud_module--Import">

    <div class="import">
      <label>
        <input type="file" id="import_file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ><br/>
        <samp>* {{$t("message.maximumQuantity", {row : max_row})}}</samp>
          <br>預覧導入數量：{{tableData.length}}
          <br>錯誤行數: {{formatArray(errorColumn)}}
      </label>
      <label v-if="setting.component" style="min-width:400px">
        請選擇推廣活動名稱
        <Component :is="setting.component.component" v-model="input[setting.component.key]" :key="setting.component.key" :ref="`component-${setting.component.key}`" :field="setting.component" :options="options"/>
      </label>
      <label v-if="setting.component2" style="min-width:400px">
        請選擇兌換券發行商場
        <Component :is="setting.component2.component" v-model="input[setting.component2.key]" :key="setting.component2.key" :ref="`component-${setting.component2.key}`" :field="setting.component2" :options="options"/>
      </label>
      <br>
      <el-button @click="importFile" type="success" size="mini">
        <fa :icon="['fas','file-import']" style="margin-right:5px;"/>{{ $t("label.importFile") }}
      </el-button>
      <el-button v-if="setting.demo_url" @click="downloadDemo" type="warning" size="mini">
        <fa :icon="['fas','file-download']" style="margin-right:5px;"/>{{ $t("label.downloadDemo") }}
      </el-button>
    </div>
    <div class="contact">
      <vxe-table
          ref="table"
          class="main-table"
          size="mini"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          height="calc(60vh)"
          :key="new Date().getTime()"
          :resizable="false"
          :loading="loading"
          :data="tableData">
        <vxe-table-column
            v-for="(field) in setting.fields" :key="field.key"
            :field="field.key"
            :title="field.key"
            :class-name="tableCellStyle"
          >
          <template v-slot:header="{ columnIndex }">
            <div class="header-wrap">
              <div class="name">
                {{ setting.fields[columnIndex].label?setting.fields[columnIndex].label:setting.fields[columnIndex].key }}
              </div>
              <!-- <div class="filter-value">{{ filter.hasOwnProperty(field.key) ? getFilterValue(field) : "" }}</div> -->
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="confirm">
        <el-button :disabled="loading || !tableDataIsSuccessAll(tableData)" @click="confirm" type="success" size="mini">
          {{ $t("label.confirmImport") }}
        </el-button>
        
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "@/plugins/modules/xlsx";
export default {
  components: {},
  props: ["setting","options"],
  beforeMount() {
    this.max_row = (this.setting.max_row?this.setting.max_row:5000);
  },
  methods: {
    async confirm(){
      if(!this.tableDataIsSuccessAll(this.tableData)){
        this.$message({
          message: this.$t('error.generic'),
          type: 'error'
        });
        return ;
      }
      this.loading=true;
      let valid = await this.$axios.post(this.setting.url, {
        fileName:this.fileName,
        importFields:this.tableData,
        ...this.input
      }).then(res=>{
        console.log(res);
        if (res?.data?.status=='error'){
          this.tableData = res?.data?.importFields;
          console.log(this.tableData);
          this.$message({
            message: this.$t('error.'+res?.data?.errorCode),
            type: 'error'
          });

          return false;
        }
        return true;
      }).catch(err=>{
        console.log(err?.response?.data);
        this.$message({
          message: this.$t("error.generic"),
          type: 'error'
        });
        return false;
      });
      if(valid){
        this.$emit("close");
      }
      else {
        this.loading=false;
      }
    },
    importFile() {
      // this.$store.commit("control/setLoad", true);
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var _this = this;
      setTimeout(async function (){
        await _this.getImportData();
        loading.close();
      },100);
    },
    async getImportData() {
      let selectedFile = document.querySelector('#import_file').files[0];
      this.tableData = [];
      this.errorColumn=[];
      if(selectedFile == undefined){
        alert(this.$t("message.pleaseSelectExcelFile"));
        return ;
      }
      // if(selectedFile.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
      //   alert(this.$t("message.pleaseSelectExcelFile"));
      //   return ;
      // }
      this.fileName = selectedFile.name;
      let fileReader = new FileReader();
      fileReader.readAsBinaryString(selectedFile);
      fileReader.onload = (event)=>{
        let data = event.target.result;
        let workbook = null;
        try {
          workbook = XLSX.read(data,{type:"binary"});
        } catch (error) {
          alert(this.$t("message.pleaseSelectExcelFile"));
          return ;
        }
        
        let maximumQuantity = this.max_row;
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
          let size = 0;
          try {
            size = rowObject.length;
          } catch (error) {
            
          }
          if(size >0) {
            if(size > maximumQuantity) {
              alert(this.$t("message.maximumQuantity", {row : maximumQuantity}));
              return ;
            }
            for (var i = 0; i < size && i<maximumQuantity; i++) {
              var data = {};
              for(var j in this.setting.fields){
                var row = this.setting.fields[j];
                var field = row.label?row.label:row.key;
                // var field = row.key;
                var val = undefined;
                if(rowObject[i][field] != undefined && rowObject[i][field] != '') {
                  if(typeof rowObject[i][field] == "string"){
                    val = rowObject[i][field].trim();
                  }
                  else val = rowObject[i][field];
                }
                else val = "";
                data[row.key]=val;
              }
              this.tableData.push(this.checking(data,this.setting.fields, i));
            }
          }
        });   
      }
    },
    downloadDemo(){
      window.location = window.origin+"/"+this.$conf.NAMESPACE+"/"+this.$conf.CURRENT_PROFILE+"/"+this.setting.demo_url;
    },
    tableCellStyle({row, column, rowIndex, columnIndex}){
      console.log(row)
      if(row.importStatus){
        return row.importStatus;
      }
    },
    tableDataIsSuccessAll(data){
      let isSuccessAll = true;
      try {
        if(data.length > 0){
          for(var i in data){
            if(data[i].importStatus==undefined || data[i].importStatus=='error'){
              isSuccessAll = false;
            }
          }
        }
        else isSuccessAll = false;
      } catch (error) {
        isSuccessAll = false;
      }
      
      return isSuccessAll;
    },
    checking(data,fields,index){
      var importStatus = 'success';
      for(var i in fields){
        var row = fields[i];
        if(row.not_null && this.isNull(data[row.key])){
            importStatus = 'error';
            break;
        }
        if(row.type == 'date' && !this.isValidDate(data[row.key])){
            importStatus = 'error';
            break;
        }
      }

      if (importStatus == 'error') {
          this.errorColumn.push(index+1);
      }

      data.importStatus = importStatus;
      return data;
    },
    isNull(val){
      console.log(val)
      if(val === "" || val === undefined){
        return true;
      }
      return false;
    },
    isValidDate(dateString){
        // First check for the pattern
        var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

        if(!regex_date.test(dateString))
        {
            return false;
        }

        // Parse the date parts to integers
        var parts   = dateString.split("-");
        var day     = parseInt(parts[2], 10);
        var month   = parseInt(parts[1], 10);
        var year    = parseInt(parts[0], 10);

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12)
        {
            return false;
        }

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        {
            monthLength[1] = 29;
        }

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    },
    // selected(obj){
    //   this.input=obj;
    // }
      formatArray(array){
          return array.join(", ");
      }
  },
  computed:{

  },
    data() {
        return {
            fileName:"",
            fields:[],
            tableData:[],
            loading:false,
            max_row:5000,
            input:{},
            errorColumn:[]
        }
    }
}
</script>

<style lang="scss">
.crud_module--Import{
  .import{
    label{
      display: inline-table;
      font-size: 14px;
      margin-right: 5px;
      samp{
        color: red;
        font-weight: bold;
      }
    }
  }
  width: 95vw;
  background: white;
  border-radius: 3px;
  overflow: auto;
  min-height: 20vh;
  max-height: 80vh;
  padding: 10px;
  // .vxe-table--body-wrapper{
  //   height: calc(100vh - 300px);
  // }
  .vxe-table--header{
    .vxe-cell{
      font-size: 12px;
    }
  }
  .vxe-table--body-wrapper{
    height: calc(100vh - 350px)!important;
  }
  .vxe-table--body{
    .success{
      background-color: #e6ffec;
    }
    .error{
      background-color: #ffd7d5;
    }
    .row-clicked{
      background: #ffe48d;
    }
    .vxe-cell{
      font-size: 12px;
    }
    .action{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .el-button{
        padding: 7px 7px;
      }
      & div > *:not(:first-child){
        margin-left: 5px;
      }
    }
  }
  .contact{
    margin-top: 10px;
  }
  .confirm{
    text-align: right;
    margin-top: 10px;
    height: 50px;
  }
}
</style>